import * as z from "zod";

export const VehicleBrandSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(255),
  description: z.string().nullable().optional(),
  logo: z.string().nullable().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createVehicleBrandSchema = VehicleBrandSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateVehicleBrandSchema = VehicleBrandSchema.pick({
  name: true,
  description: true,
  logo: true,
}).partial();
